export const css = {
	icon: '_1fXJU5m6',
	clockIcon: '_3MiGj6k2',
	eyeIcon: '_3lrHvkrC',
	eyeSlashIcon: '_1WYUBmrn',
	plusIcon: '_1kbYLzs6',
	minusIcon: '_1S3obdVp',
	checkIcon: '_3TChflmG',
	closeIcon: '_2kY2hIbq',
	leftIcon: '_1gvrPj7V',
	rightIcon: '_2hOUt6u2',
	upIcon: '_2CV43762',
	downIcon: 'yYB4fH8-',
	upAltIcon: '_1jekrgAD',
	downAltIcon: '_3B0jynrO',
	searchIcon: 'atYfB8PH',
	barsIcon: '_3K9ACSu3',
	settingsIcon: '_3gXZ7fZt',
	alertIcon: '_1FLoAF69',
	helpIcon: '_3j60sXzk',
	infoIcon: '_2_nw0QOY',
	cancelIcon: '_38At0Dgj',
	checkedBoxIcon: '_2cNDIETo',
	phoneIcon: '_1xOgctsz',
	editIcon: '_2p65K32-',
	dateIcon: '_3JnDtJxM',
	linkIcon: '_322RjkDY',
	locationIcon: '_2qsuYs9N',
	secureIcon: '_3ASLnsZ5',
	mailIcon: '_3Ci9IlF5',
	starIcon: '_2yLwawje',
	' _key': 'ascm-theme/ascm/dojo/icon'
};

export default css;
